var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.referralNumber
    ? _c(
        "div",
        [
          _c(
            "MatchMedia",
            [
              _vm._l(_vm.sectionsWithDueTotal, function(section, key) {
                return [
                  _c(
                    "div",
                    { key: key, staticClass: "mt-3" },
                    [
                      _c(
                        "b-skeleton-wrapper",
                        {
                          attrs: { loading: _vm.loading },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "loading",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-card",
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-skeleton", {
                                                  attrs: { width: "85%" }
                                                }),
                                                _c("b-skeleton", {
                                                  attrs: { width: "55%" }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-skeleton", {
                                                  attrs: { width: "70%" }
                                                }),
                                                _c("b-skeleton", {
                                                  attrs: { width: "55%" }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-skeleton", {
                                                  attrs: { width: "85%" }
                                                }),
                                                _c("b-skeleton", {
                                                  attrs: { width: "55%" }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-skeleton", {
                                                  attrs: { width: "70%" }
                                                }),
                                                _c("b-skeleton", {
                                                  attrs: { width: "55%" }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    type: "button",
                                                    width: "100%"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._l(section.items, function(item, i) {
                            return [
                              _c(
                                "b-card",
                                {
                                  key: i,
                                  staticClass: "bg-light-gray border-0",
                                  class: { "mt-2": i > 0 }
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      key ===
                                      _vm.INTERVENTION_TYPES
                                        .REQUEST_FOR_COMPENSATORY_HOURS
                                        ? [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12", md: "" } },
                                              [
                                                _c(
                                                  "dl",
                                                  { staticClass: "m-0" },
                                                  [
                                                    _c(
                                                      "dd",
                                                      { staticClass: "m-0" },
                                                      [
                                                        _c("Balloon", {
                                                          staticClass:
                                                            "border-none text-center font-15",
                                                          attrs: {
                                                            bg: `bg-${_vm.getStatusColor(
                                                              item.statusId
                                                            )}`,
                                                            dot: "",
                                                            text: item.status
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "dd",
                                                      { staticClass: "m-0" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.requestNumber
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "b-col",
                                        {
                                          class: {
                                            "mt-2 mt-md-0":
                                              key ===
                                              _vm.INTERVENTION_TYPES
                                                .REQUEST_FOR_COMPENSATORY_HOURS
                                          },
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          _c(
                                            "dl",
                                            {
                                              staticClass: "m-0 text-md-center"
                                            },
                                            [
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "m-0 text-muted small"
                                                },
                                                [_vm._v(" Año Académico: ")]
                                              ),
                                              _c("dd", { staticClass: "m-0" }, [
                                                _vm._v(
                                                  _vm._s(item.academicYearDesc)
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-2 mt-md-0",
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          _c(
                                            "dl",
                                            {
                                              staticClass: "m-0 text-md-center"
                                            },
                                            [
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "m-0 text-muted small"
                                                },
                                                [_vm._v(" Procedencia: ")]
                                              ),
                                              _c("dd", { staticClass: "m-0" }, [
                                                _vm._v(
                                                  _vm._s(item.detail.sourceApp)
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-2 mt-md-0",
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          _c(
                                            "dl",
                                            {
                                              staticClass: "m-0 text-md-center"
                                            },
                                            [
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "m-0 text-muted small"
                                                },
                                                [
                                                  _vm._v(
                                                    " Intervenciones Adeudadas: "
                                                  )
                                                ]
                                              ),
                                              _c("dd", { staticClass: "m-0" }, [
                                                _vm._v(
                                                  _vm._s(item.interventionsDue)
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-2 mt-md-0",
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          _c(
                                            "dl",
                                            {
                                              staticClass: "m-0 text-md-center"
                                            },
                                            [
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "m-0 text-muted small"
                                                },
                                                [
                                                  _vm._v(
                                                    " Intervenciones Ofrecidas: "
                                                  )
                                                ]
                                              ),
                                              _c("dd", { staticClass: "m-0" }, [
                                                _vm._v(
                                                  _vm._s(
                                                    item.interventionsOffered
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-2 mt-md-0",
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          _c(
                                            "dl",
                                            {
                                              staticClass: "m-0 text-md-center"
                                            },
                                            [
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "m-0 text-muted small"
                                                },
                                                [_vm._v(" Balance: ")]
                                              ),
                                              _c("dd", { staticClass: "m-0" }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.isRejectedOrCompletedStatus(
                                                        item
                                                      )
                                                        ? 0
                                                        : item.interventionsDueTotal
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "mt-2 mt-md-0 text-md-right",
                                          attrs: { cols: "12", md: "" }
                                        },
                                        [
                                          key ===
                                          _vm.INTERVENTION_TYPES
                                            .REQUEST_FOR_COMPENSATORY_HOURS
                                            ? [
                                                _c("DropDown", {
                                                  attrs: {
                                                    "data-item": { item, i },
                                                    items: _vm.actionItems
                                                  }
                                                })
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    2
                                  ),
                                  item.isSigned && item.selectedToCompensate
                                    ? _c("error", {
                                        attrs: {
                                          "is-alert-mode": "",
                                          message:
                                            "La planilla fue marcada para compensar los servicios durante el año, mediante la revisión de PEI."
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }),
                          section.items && section.items.length === 0
                            ? _c("CustomResultNotFound", {
                                attrs: {
                                  text: `No posee registros de ${_vm.sections[key].title}`
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }